var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8436 0.33252H7.21147C2.60815 0.33252 0 2.94067 0 7.54399V20.1641C0 24.7674 2.60815 27.3755 7.21147 27.3755H19.8436C24.4469 27.3755 27.043 24.7674 27.043 20.1641V7.54399C27.043 2.94067 24.4469 0.33252 19.8436 0.33252Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5205 16.0894C10.4831 16.0894 7.88867 16.5682 7.88867 18.4838C7.88867 20.4 10.4669 20.8958 13.5205 20.8958C16.5579 20.8958 19.1524 20.4176 19.1524 18.5014C19.1524 16.5851 16.5748 16.0894 13.5205 16.0894Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.5218 14.2648C15.5909 14.2648 17.2487 12.6063 17.2487 10.5379C17.2487 8.46953 15.5909 6.81104 13.5218 6.81104C11.4534 6.81104 9.79492 8.46953 9.79492 10.5379C9.79492 12.6063 11.4534 14.2648 13.5218 14.2648Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.cb661f76f74b93aea872e831d532917a.svg";
export { ForwardRef as ReactComponent };